import React from "react";
import "./style.scss";
import OkIcon from "./img/ok.svg";
import InputError from "../InputError/InputError";
const inputClass = {
  base: "input",
  error: "error",
  disabled: "disabled",
};

export default function Textarea({
  label,
  disabled,
  required,
  placeholder,
  name,
  icon,
  register,
  errors = {},
  touched = false,
  validationRules,
  ...rest
}) {
  const showIsValid = !errors?.message && touched;
  const errorMessage = errors?.message;

  return (
    <div className="textarea-wrapper">
      <div className="top">
        <label className="label" htmlFor={name}>
          {label}
        </label>

        {showIsValid && (
          <div className="ok">
            <img src={OkIcon} alt="ok-icon" />
          </div>
        )}
      </div>
      <div className="input-container">
        <textarea
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          className={`${inputClass.base} 
          ${errorMessage ? inputClass.error : ""} 
          ${disabled ? inputClass.disabled : ""}`}
          {...register(`${name}`, {
            ...validationRules,
          })}
          {...rest}
        />
        {icon && <img className="icon" src={icon} alt="placeholder" />}
      </div>

      {errorMessage && <InputError reverse errorMessage={errorMessage} />}
    </div>
  );
}
